/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Col_ArrowInputs */

const en_pwf_col_arrow = /** @type {(inputs: Pwf_Col_ArrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moves to`)
};

const de_pwf_col_arrow = /** @type {(inputs: Pwf_Col_ArrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`wandert zu`)
};

/**
* | output |
* | --- |
* | "moves to" |
*
* @param {Pwf_Col_ArrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_col_arrow = /** @type {((inputs?: Pwf_Col_ArrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Col_ArrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_col_arrow(inputs)
	return en_pwf_col_arrow(inputs)
});